import { v4 } from 'uuid';

import { nullOperators } from '../constants/filter';
import { isEventSpecificField } from './event/common';

const operatorsText = {
  is_null: 'is null',
  not_null: 'not null',
  between: 'between',
  not_in: 'none of',
  '=': '=',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
  in: 'any of',
  ANY: 'any of',
  ALL: 'all of',
  NONE: 'none of',
  regexp: 'regexp',
  not_regexp: 'not regexp',
  like_case_insensitive: 'like',
  not_like_case_insensitive: 'not like',
};

export const getOperatorText = (operator) => operatorsText[operator];

export const extractMetaFor = (field, metainf) => (field ? { ...metainf.meta[field], field } : {});

export const getEventAttributes = (metainf, firstEvent, secondEvent) => {
  // аттрибуты для первого и второго ивента
  const eventsAttributes = metainf.groups.find(({ events }) => !!events) || { events: {} };
  const firstEventFields = eventsAttributes.events[firstEvent] || [];
  const secondEventFields = eventsAttributes.events[secondEvent] || [];
  return {
    firstEventFields,
    secondEventFields,
  };
};

export const excludeEventSpecificClauses = (filter, event, newEvent, eventMetainf) => ({
  ...filter,
  clauses: filter.clauses.reduce((res, c) => {
    if (isEventSpecificField(c.field)) {
      const { firstEventFields, secondEventFields } = getEventAttributes(
        eventMetainf,
        event,
        newEvent
      );
      const field = firstEventFields.find((item) => item.path === c.field);
      const newField = secondEventFields.find((item) => item.label === field.label);

      return newField ? res.concat({ ...c, field: newField.path }) : res;
    }
    return res.concat(c);
  }, []),
});

// возвращает объект который содержит те поля которые нужно перенести с одного фильтра на другой.
// ключами будет являются path из первого ивента(с которого копируются данные).
// значениями являются path на который нужно исходный.
export const getTransferFieldsObject = (fieldTypes, commonAttributes, secondEventFields) =>
  fieldTypes.reduce((res, item) => {
    const commonAttr = commonAttributes.find(
      (commonAttribute) => commonAttribute.label === item.label
    );

    if (isEventSpecificField(item.path) && !!commonAttr) {
      const field = secondEventFields.find((fieldItem) => fieldItem.label === commonAttr.label);
      return {
        ...res,
        [item.path]: field.path,
      };
    }
    return { ...res, [item.path]: item.path };
  }, {});

export const isNotEmptyValue = (value) => value != null && !(Array.isArray(value) && !value.length);
export const isNotEmptyClause = ({ value, operator }) =>
  nullOperators.includes(operator) || isNotEmptyValue(value);

export const filterClauses = (metainf, clauses) =>
  clauses
    .filter((clause) => !!metainf.meta[clause.field])
    .map((clause) => ({ ...clause, id: v4() }));
